'use strict';

import App from './app/app';

document.addEventListener('DOMContentLoaded', () => {
    const app = new App();
}, false);